const ACCESS_TOKEN_NAME = 'access_tk'
const REFRESH_TOKEN_NAME = 'refresh_tk'

const TokenService = {
  parseJwt(token) {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) =>
      '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    ).join(''))

    return JSON.parse(jsonPayload)
  },
  setTokens(access, refresh) {
    localStorage.setItem(ACCESS_TOKEN_NAME, access)
    localStorage.setItem(REFRESH_TOKEN_NAME, refresh)
  },
  clearTokens() {
    localStorage.removeItem(ACCESS_TOKEN_NAME)
    localStorage.removeItem(REFRESH_TOKEN_NAME)
  },
  getTokens() {
    return {
      access: localStorage.getItem(ACCESS_TOKEN_NAME),
      refresh: localStorage.getItem(REFRESH_TOKEN_NAME)
    }
  }
}

export default TokenService
